import React, { useState } from "react";
import styled from "styled-components";
import Hero from "../../components/Hero";
import BlockTwo from '../../components/BlockTwo';
import BlockThree from "../../components/BlockThree";
import BlockFour from "../../components/BlockFour";
import BlockFive from "../../components/BlockFive";
import BlockSix from "../../components/BlockSix";
import BlockSeven from "../../components/BlockSeven";
import BlockEight from "../../components/BlockEight";
import BlockNine from "../../components/BlockNine"
import BlockTen from "../../components/BlockTen"
import BlockEleven from "../../components/BlockEleven"
import BlockSeventeen from "../../components/BlockSeventeen"
import BlockEighteen from "../../components/BlockEighteen"
import About from "../../components/About"
import PlansSection from "../../components/PlansSection"
import TestimonialsSection from "../../components/TestimonialsSection"
import FAQSection from "../../components/FAQ"
import CTASection from "../../components/CTASection"

import BlockTwentyTwo from "../../components/BlockTwentyTwo"



const Home: React.FC = () => {

  
 
  return (
    <div>
      <div>
      <div id="hero">
          <Hero />
        </div>   

        <div id="why">
          <BlockThree />
        </div>        <PlansSection/>

 <BlockEight/> <BlockNine/>
 <TestimonialsSection/>
 <FAQSection/>
 <CTASection/>

     {/* <TransactionRow />
<AuditHome /> */}
      </div>
      </div>
  );
};

export default Home;
